import { apiClient, Auth } from '@/shared/api'

import { TDepositReturnAccount } from '../model/schema'

export const getGuestDepositReturnAccount = async (contractId: number) => {
  const { data } = await apiClient.get<TDepositReturnAccount>({
    endpoint: `/guest/contracts/${contractId}/deposit-return-account`,
    auth: Auth.REQUIRED,
  })

  return data
}
